import '../vendor';

import '../general/ofi';
import '../general/signlogin';
import '../general/reg';
import '../general/modal';
import '../general/menu';
import '../general/filter';
import '../general/anchor';

import '../pages/main/preorder';
import '../pages/main/slider-arrows';
import '../pages/main/slider-dots';
import '../pages/main/slider-numbers';
import '../pages/main/slider-close';
import '../pages/main/gallery';
import '../pages/main/game-trailer';
import '../pages/main/cloud';
import '../pages/main/paths';
import '../pages/main/subscribe';
import '../pages/main/tabs';
import '../pages/main/zoom';
import '../pages/main/bonus';
import '../pages/main/info';
import '../pages/main/modal';
import '../pages/main/content-button';
import '../pages/main/store';
import '../pages/main/features';
import '../pages/main/news';


// WEBPACK FOOTER //
// ./src/js/pages/main.js